import { Fragment } from "react";
import styled from "styled-components";

type FieldDescProps = {
  title?: string;
  noti?: string;
  list?: { title: string; desc: string; emph?: boolean }[];
};

const FieldDescWrapper = styled.div`
  margin: 1rem 0 3rem;
  padding: 2rem 0;
  border-top: 1px solid #ececec;
  .txt_title {
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 700;
  }
  .list_desc .txt_title {
    margin-top: 1rem;
  }
  .list_desc .txt_desc {
    margin-top: 0.4rem;
    font-size: 1.4rem;
    line-height: 2.2rem;
  }
  .list_desc .txt_desc .emph {
    font-size: 1.6rem;
    font-weight: 700;
  }
  .txt_noti {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid #ececec;
    font-size: 1.4rem;
    line-height: 2.2rem;
  }
`;

const FieldDesc = ({ title, noti, list, ...props }: FieldDescProps) => {
  return (
    <>
      <FieldDescWrapper {...props}>
        <strong className="txt_title">{title}</strong>
        <dl className="list_desc">
          {list?.map((el, idx) => (
            <Fragment key={idx}>
              <dt className="txt_title">{el.title}</dt>
              {(el.emph && (
                <dd className="txt_desc">
                  <strong className="emph">{el.desc}</strong>
                </dd>
              )) || <dd className="txt_desc">{el.desc}</dd>}
            </Fragment>
          ))}
        </dl>
        <p className="txt_noti">{noti}</p>
      </FieldDescWrapper>
    </>
  );
};

export default FieldDesc;
export type { FieldDescProps };
